import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LegacyStyleVariants, StyleVariants } from '@site-mate/dashpivot-shared-library';

@Component({
  selector: 'cc-style-color-picker',
  templateUrl: './style-color-picker.html',
  styleUrls: ['./style-color-picker.scss'],
})
export class StyleColorPicker {
  colorPickerOptions: StyleVariants[] | LegacyStyleVariants[];

  @Input() style: StyleVariants | LegacyStyleVariants;

  @Input() disabled = false;
  @Output() styleChange = new EventEmitter<any>();

  @Input() defaultStyle = StyleVariants.Sky;

  ngOnInit(): void {
    this.colorPickerOptions = Object.values(StyleVariants);
  }

  setStyle(style: StyleVariants | LegacyStyleVariants) {
    this.style = style;
    this.styleChange.emit(this.style);
  }
}
